import { render, staticRenderFns } from "./ParallaxTab.vue?vue&type=template&id=65838b56&"
import script from "./ParallaxTab.vue?vue&type=script&lang=js&"
export * from "./ParallaxTab.vue?vue&type=script&lang=js&"
import style0 from "./ParallaxTab.vue?vue&type=style&index=0&id=65838b56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports